import { toast } from 'vue3-toastify';
import type { ToastOptions } from 'vue3-toastify';
import type { Plugin } from 'vue';

export const createDelayedToastPlugin = (delay: number = 10): Plugin => {
	return {
		install() {
			const original = {
				success: toast.success.bind(toast),
				error: toast.error.bind(toast),
				info: toast.info.bind(toast),
				warning: toast.warning.bind(toast),
				loading: toast.loading.bind(toast),
			};
			
			const wrapWithDelay = (fn: (msg: string, opts?: ToastOptions) => any) => {
				return (message: string, options?: ToastOptions) => {
					setTimeout(() => fn(message, options), delay);
				};
			};
			
			const wrapLoadingWithDelay = (fn: any) => {
				return (message: string, options?: ToastOptions) => {
					return new Promise((resolve) => {
						setTimeout(() => resolve(fn(message, options)), delay);
					});
				};
			};
			
			toast.success = wrapWithDelay(original.success) as any;
			toast.error = wrapWithDelay(original.error) as any;
			toast.info = wrapWithDelay(original.info) as any;
			toast.warning = wrapWithDelay(original.warning) as any;
			toast.loading = wrapLoadingWithDelay(original.loading) as any;
		}
	};
};

export const DelayedToastPlugin = createDelayedToastPlugin(10);
export default DelayedToastPlugin;
